import React, { FC } from 'react';
import { MenuItem } from '@mui/material';
import { jobRateSelectOptions } from '@efacity/common';
import { FormInputTextProps, FormTextInput } from './FormTextInput';

export const JobPostingRateSelector: FC<FormInputTextProps> = ({ name, ...props }) => {
  return (
    <FormTextInput name={name} label="Rate" select {...props}>
      {jobRateSelectOptions.map(({ value, label }) => (
        <MenuItem key={value} value={value}>
          {label}
        </MenuItem>
      ))}
    </FormTextInput>
  );
};
